var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cardFaceContainer",staticClass:"card-face-container"},[_c('img',{staticClass:"card-image",attrs:{"src":_vm.sideImageUrl,"alt":_vm.sideImageAlt}})])}
var staticRenderFns = []

export { render, staticRenderFns }